import webBiLogger from '@wix/web-bi-logger';
import { Logger } from '@wix/web-bi-logger/dist/src/types';

const config = window.__CONFIG__;
const tags = window.__CAMPAIGN__.tags || [];

const logger = webBiLogger
  .factory()
  .updateDefaults({
    src: 36,
    uuid: config.clientId || config.userId,
    page_id: config.messageId,
    ver: process.env.ARTIFACT_VERSION,
    context: tags.includes('#ping')
      ? 'apes'
      : tags.includes('#automation')
      ? 'transactional-emails-automations'
      : tags.includes('#transactional')
      ? 'transactional-emails'
      : 'shoutout',
    msid: config.metaSiteId,
  })
  .withUoUContext({
    msid: config.metaSiteId,
  })
  .setMuted(isMuted())
  .logger();

export function useBiLogger(): Logger {
  return logger;
}

// Inside preview/snapshot phase we don't need to fire BI events.
function isMuted() {
  try {
    const params = new URLSearchParams(window.location.search);
    return !!params.get('render');
  } catch {
    return false;
  }
}
